import * as signalR from "@microsoft/signalr";
import { ReactNode, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { createSignalRContext } from "react-signalr";

import { API_PATHS } from "../api";

const SignalRContext = createSignalRContext();

export const SignalRContextProvider = ({ children }: { children: ReactNode }) => {
    const [cookies] = useCookies(["accessToken"]);
    
    return (
        <SignalRContext.Provider
            url={`${API_PATHS.BASE_URLS.API_URL}/notifications`}
            accessTokenFactory={() => {
                return cookies.accessToken as string;
            }}
            dependencies={[cookies.accessToken]}
        >
        {children}
        </SignalRContext.Provider>
    );
}

export const { useSignalREffect } = SignalRContext;

export const useSignalR = (
    url: string,
    handlers: [string, (msg: any) => void][],
    dependencies: any[]
    // subscribeArgs?: any[]
) => {
    const [cookies] = useCookies(["accessToken"]);
    const [connection, setConnection] = useState<signalR.HubConnection | null>(null);

    useEffect(() => {
        if (!cookies.accessToken) return;

        const c = new signalR.HubConnectionBuilder()
            .withUrl(
                url,
                {
                    accessTokenFactory: () => cookies.accessToken as string
                }
            )
            .withAutomaticReconnect()
            .build();

        handlers.forEach(([eventName, callback]) => {
            c.on(eventName, callback);
        });

       
        setConnection(c);
    }, dependencies);

    return connection;
};